import React, { useEffect, useState } from "react";
import "./Recents.css";
import { authFetch } from "./authFetch";

export default function Recents() {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState("");

  const API = process.env.REACT_APP_API_BASE_URL;

 // console.log("🔵 DEBUG: API BASE URL =", API);

  async function fetchUploads() {
    //console.log("🔵 DEBUG: Calling:", `${API}/admin/uploads`);

    try {
      const res = await authFetch(`${API}/admin/uploads`);

     // console.log("🔵 DEBUG: Response status =", res.status);

      if (!res.ok) {
      //  console.error("🔴 DEBUG: Bad response:", res);
        throw new Error(`Fetch failed with status ${res.status}`);
      }

      const data = await res.json();

// filter only CSV batches
const csvOnly = (data.items || []).filter(
  (u) => u.batchId && u.batchId.startsWith("CSV")
);

setUploads(csvOnly);

    } catch (err) {
      //console.error("🔴 ERROR LOADING UPLOADS:", err);
    } finally {
      setLoading(false);
    }
  }

  async function deleteBatch(batchId) {
    const ok = window.confirm(
      `Delete batch ${batchId}?\n\nThis will remove ALL orders that belong to this CSV.`
    );
    if (!ok) return;

    setDeleting(batchId);

    try {
      const url = `${API}/admin/delete-batch/${batchId}`;
     // console.log("🟠 DEBUG: DELETE CALL =", url);

      const res = await authFetch(url, { method: "DELETE" });

      const data = await res.json();
      alert(data.message || "Batch deleted.");
      fetchUploads();
    } catch (err) {
      //console.error("🔴 ERROR deleting batch:", err);
      alert("Failed to delete batch.");
    } finally {
      setDeleting("");
    }
  }

  useEffect(() => {
    fetchUploads();
  }, []);

  return (
    <div className="recents-wrapper">
      <h1 className="recents-title">Recent CSV Uploads</h1>

      {loading && <p className="loading">Loading…</p>}

      {!loading && uploads.length === 0 && (
        <p className="empty">No uploads recorded yet.</p>
      )}

      <div className="recents-list">
        {uploads.map((u) => (
          <div key={u.batchId} className="recent-card">
            <div className="card-left">
              <h2 className="file">{u.fileName}</h2>

              <p className="row">
                <strong>Batch ID:</strong> {u.batchId}
              </p>
              <p className="row">
                <strong>Inserted:</strong> {u.insertedCount}
              </p>
              <p className="row">
                <strong>Updated:</strong> {u.updatedCount}
              </p>

              {u.uploadedAt && (
                <p className="row">
                  <strong>Uploaded:</strong> {u.uploadedAt}
                </p>
              )}
            </div>

            <button
              className="delete-btn"
              disabled={deleting === u.batchId}
              onClick={() => deleteBatch(u.batchId)}
            >
              {deleting === u.batchId ? "Deleting…" : "Delete Batch"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
